// extracted by mini-css-extract-plugin
module.exports = {"text":"groupsList_text__2KyZi","groupsBlock":"groupsList_groupsBlock__3CveA","groupsContainer":"groupsList_groupsContainer__2Ubw7"};